import { createContext, useContext, useState } from 'react'

import { CssBaseline, StyledEngineProvider, Theme, ThemeProvider } from '@mui/material'
import { defaultTheme, samsungTheme } from 'config/theme'

type ThemeConfigContextType = {
  theme: Theme
  setTheme: (vendorShortName: string | undefined) => void
}

const ThemeConfigContext = createContext<ThemeConfigContextType>({
  theme: defaultTheme,
  setTheme: () => null,
})

export const ThemeConfigContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [theme, setTheme] = useState<Theme>(defaultTheme)

  const handleSetTheme = (val: string | undefined) => {
    switch (val) {
      case 'SEPL':
        setTheme(samsungTheme)
        break
      default:
        setTheme(defaultTheme)
        break
    }
  }

  return (
    <ThemeConfigContext.Provider value={{ theme, setTheme: handleSetTheme }}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {children}
        </ThemeProvider>
      </StyledEngineProvider>
    </ThemeConfigContext.Provider>
  )
}

export const useThemeConfigContext = () => useContext(ThemeConfigContext)
